let overlayCheck: boolean = false;

export const overlayGuard = {
  enter() {
    overlayCheck = true;
  },

  exit() {
    overlayCheck = false;
  },

  isActive() {
    return overlayCheck;
  },
};
